import React, { useMemo } from 'react';
import { AppSkinProps } from '../../../types/decisions';
import AppResults from '../app-components/AppResults/AppResults';
import CriteriaImportanceAndSettings from '../app-components/CriteriaImportanceAndSettings';
import Loading from '../../loading/Loading';
import { useAppConfig } from '../../../context/app-configs-context';
import AppInfo from '../app-components/AppInfo';
import { getCriteriaFieldsToDisplayInCriteria, getCriteriaFieldsToDisplayInResults } from '../../../utils';

const AppSkin4 = ({
    results,
    onRerank,
    onRerankMany,
    criteriaLoading,
    criteriaData,
    criteriaConstraints,
    onSliderChange,
    onResetTradeOffs,
    onCriteriaApply,
    resultLoading,
    onPageChange,
    pageInfo,
    onTradeoffValueChange,
    fieldInitialValues,
    selectedProductIds,
    setSelectedProductIds,
}: AppSkinProps) => {
    const { appConfigs } = useAppConfig();
    const shouldShowRankByManyCheckbox = appConfigs.inferenceRank === 'ThumbsUp';

    const displayFieldsIds: string[] = useMemo(() => {
        return getCriteriaFieldsToDisplayInResults(criteriaData.fields)
        .map(item => item.id);
    }, [ criteriaData.fields ]);

    return (
        <div className="application">
            {criteriaLoading ? (
                <Loading/>
            ) : (
                <>
                    <AppInfo
                        icon={criteriaData.icon}
                        name={criteriaData.name}
                        description={criteriaData.description}
                    />
                    <div className="application-details">
                        <div className="app-criteria" id="app-criteria">
                            {criteriaLoading ? (
                                <Loading/>
                            ) : (
                                <CriteriaImportanceAndSettings
                                    criteriaFields={getCriteriaFieldsToDisplayInCriteria(criteriaData.fields)}
                                    onSliderChange={onSliderChange}
                                    fieldInitialValues={fieldInitialValues}
                                    onTradeoffValueChange={onTradeoffValueChange}
                                    onResetTradeOffs={onResetTradeOffs}
                                    onCriteriaApply={onCriteriaApply}
                                    externalItems={appConfigs.show.menuItems.externalItems}
                                />
                            )}
                        </div>
                        <div className="app-results">
                            {resultLoading ? (
                                <Loading/>
                            ) : (
                                <AppResults
                                    results={results}
                                    pageInfo={pageInfo}
                                    onPageChange={onPageChange}
                                    onRerank={onRerank}
                                    onRerankMany={onRerankMany}
                                    shouldShowRankByManyCheckbox={shouldShowRankByManyCheckbox}
                                    selectedProductIds={selectedProductIds}
                                    setSelectedProductIds={setSelectedProductIds}
                                    allowedFieldsIds={displayFieldsIds}
                                    criteriaData={criteriaData}
                                    criteriaConstraints={criteriaConstraints}
                                />
                            )}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default AppSkin4;